import { render, staticRenderFns } from "./EspondiloartritesMedicineHistoryPhase.vue?vue&type=template&id=c8642f2a&scoped=true&"
import script from "./EspondiloartritesMedicineHistoryPhase.vue?vue&type=script&lang=js&"
export * from "./EspondiloartritesMedicineHistoryPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8642f2a",
  null
  
)

export default component.exports